export default __webpack_public_path__ + "static/media/ironMan.ebeae414.PNG";